import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { api } from '../../context/AuthContext';

// Admin: Wartungshinweis auf der Login-Seite manuell ein-/ausschalten
export const WartungsHinweisEinstellung = () => {
  const [d, setD] = useState(null);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  useEffect(() => { api.get('/admin/wartung').then((r) => { setD(r.data); setText(r.data.text); }).catch(() => setD(false)); }, []);
  const speichern = async (aktiv) => {
    setBusy(true); setMsg('');
    try { const r = await api.put('/admin/wartung', { aktiv, text }); setD(r.data); setText(r.data.text); setMsg(aktiv ? 'Hinweis ist jetzt auf der Login-Seite sichtbar.' : 'Hinweis ausgeschaltet.'); } catch (x) { setMsg(x?.response?.data?.detail || 'Speichern fehlgeschlagen'); }
    setBusy(false);
  };
  if (d === null) return <Loader2 className="w-4 h-4 animate-spin text-[#b8893d]" />;
  if (d === false) return <p className="text-xs text-rose-700">Einstellung konnte nicht geladen werden.</p>;
  return (
    <div className="space-y-3" data-testid="wartung-einstellung">
      <p className="text-sm" data-testid="wartung-status">Status: <b className={d.aktiv ? 'text-amber-700' : 'text-emerald-700'}>{d.aktiv ? 'Hinweis eingeschaltet' : 'ausgeschaltet'}</b>{d.geaendert_von && <span className="text-xs text-gray-500"> · zuletzt {d.geaendert_von}, {new Date(d.geaendert_am).toLocaleString('de-DE')}</span>}</p>
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} maxLength={500} className="w-full px-3 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:border-[#b8893d]" data-testid="wartung-text" />
      <div className="flex flex-wrap items-center gap-2">
        <button type="button" disabled={busy} onClick={() => speichern(true)} className="h-9 px-4 rounded-full bg-[#b8893d] text-white text-xs hover:bg-[#a5782f] disabled:opacity-50" data-testid="wartung-einschalten">{d.aktiv ? 'Text aktualisieren' : 'Hinweis einschalten'}</button>
        {d.aktiv && <button type="button" disabled={busy} onClick={() => speichern(false)} className="h-9 px-4 rounded-full border border-gray-200 text-xs text-[#1B3A5C] hover:border-[#b8893d] disabled:opacity-50" data-testid="wartung-ausschalten">Hinweis ausschalten</button>}
        {msg && <span className="text-xs text-[#34536b]" data-testid="wartung-meldung">{msg}</span>}
      </div>
    </div>
  );
};

export default WartungsHinweisEinstellung;
